export function resetAreaSelector()
{
	$('#areaSelectorBox').addClass('hidden');
	if( !$('#r_arrow').hasClass('isBeingDisplayed') && $('.search-calendar-wrapper').hasClass('hidden') )
	{
		$('#esmark-map').removeClass('hidden');
	}
	$('#areaSelectorBox').addClass('hidden');
}
